export default __webpack_public_path__ + "logo-google-play-it-ffddb19df2e9b5bb1de0a8e7ba891ea4.svg";